import Image from "next/image";
import { FC, useEffect, useRef, useState } from "react";
import { inject, observer } from "mobx-react";
import closeImg from "../../../new-images/closeicon.svg";
import AuthStore from "../../../stores/AuthStore";

import styles from "./styles.module.scss";

type TriggerPopupProps = {
  setIsPopup: (isPopup: boolean) => void;
  authStore: AuthStore
}

const TriggerPopup: FC<TriggerPopupProps> = (props) => {

  const {
    setIsPopup,
    authStore
  } = props

  const formRef = useRef(null);
  const [step, setStep] = useState(1);
  const [newEmail, setNewEmail] = useState("");
  const [confirmCode, setConfirmCode] = useState("");
  const [errors, setErrors] = useState("");
  const [count, setCount] = useState(60)
  const [intervalId, setIntervalId] = useState(null);

  const handleClosePopup = (e) => {
    if (e.target === e.currentTarget) {
      setIsPopup(false);
    }
  };

  const dontShow = (withClose = true) => {
    ym(process.env.NEXT_PUBLIC_YANDEX_KEY, 'reachGoal', 'trigger_dont_show')
    const currentDate = new Date();
    const moscowTime = new Date(
      currentDate.toLocaleString("en-US", { timeZone: "Europe/Moscow" })
    );
    const year = moscowTime.getFullYear();
    const month = String(moscowTime.getMonth() + 1).padStart(2, "0");
    const day = String(moscowTime.getDate()).padStart(2, "0");
    const date = `${year}-${month}-${day}`;

    const key: any = "email_inactive_trigger_hidden_at";

    authStore
      .updateMetadata({ [key]: date })
      .then(() => {
        if (withClose) {
          setIsPopup(false)
        } else {
          setStep(4)
        }
      })
      .catch((err) => console.log(err));
  }

  const subscribe = async () => {
    ym(process.env.NEXT_PUBLIC_YANDEX_KEY, 'reachGoal', 'trigger_subscribe')
    if (formRef.current) {
      formRef.current.submit();
    }
  }

  const resendEmail = () => {
    authStore
      .change_email(newEmail)
      .then((res) => {
        setErrors("")
        setStep(3)
      })
      .catch((err) => setErrors(err.response.data?.email[0]));
  };

  const handleConfirmCodeEmail = () => {
    authStore
      .confirm_email(newEmail, confirmCode)
      .then((res) => {
        setErrors("")
        dontShow(false)
      })
      .catch((err) => setErrors(err.response.data?.code[0]));
  };

  const handleChangeCount = () => {
    if (step === 3) {
      const id = setInterval(() => {
        setCount((prev) => (prev >= 1 ? prev - 1 : 0));
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
    }
  };

  const requestCodeResend = () => {
    if (count === 0) {
      resendEmail();
      setCount(60);
    }
  };

  const handleChangeEmail = () => {
    ym(process.env.NEXT_PUBLIC_YANDEX_KEY, 'reachGoal', 'trigger_change_email')
    setStep(2)
  }

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://sendsay.ru/account/js/formCheck.js?20170516';
    document.body.appendChild(script);
  }, [])

  useEffect(() => {
    handleChangeCount();
  }, [step])

  return (
    <div className={styles.Overlay} onClick={handleClosePopup}>
      <div className={styles.Popup}>
        <div className={styles.PopupClose}>
          <Image
            src={closeImg}
            width={24}
            height={24}
            onClick={handleClosePopup}
          />
        </div>

        <div className={styles.PopupContent}>
          <p
            className={styles.PopupContent_Title}
            style={{ color: step === 4 ? "#29b16d" : "" }}
          >
            {
              step !== 4 ?
                'Похоже, Вы пропустили наши последние новости о донорстве!'
                : 'Почта успешно изменена!'
            }
          </p>

          {
            step === 1 &&
            <>
              <p className={styles.PopupContent_Text}>Чтобы всегда быть в курсе, обновите свою почту или подпишитесь на рассылку</p>

              <div className={styles.PopupContent_Buttons}>
                <div className={styles.PopupContent_Buttons__Controllers}>
                  <button
                    className={styles.ChangeEmailButton}
                    onClick={() => handleChangeEmail()}
                  >
                    Сменить почту
                  </button>
                  <button
                    className={styles.SubscribeButton}
                    onClick={subscribe}
                  >
                    Подписаться на рассылку
                  </button>
                </div>

                <p
                  className={styles.PopupContent_Buttons__DontShow}
                  onClick={() => dontShow()}
                >
                  Больше не показывать
                </p>
              </div>
              <form
                ref={formRef}
                action="https://sendsay.ru/form/donorsearch/10/"
                method="post"
              >
                <label>Email*<input name="_member_email" value={authStore.user.email} /></label>
                <input type="submit" value="submit" />
              </form>
            </>
          }

          {
            step === 2 &&
            <>
              <div className={styles.PopupContent_NewEmail}>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Укажите email для связи"
                  className={errors && styles.RedBorder}
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                />
                {errors && <p>{errors}</p>}
              </div>

              <div className={styles.PopupContent_Buttons}>
                <div className={styles.PopupContent_Buttons__Controllers}>
                  <button
                    className={`${styles.ChangeEmailButton} ${styles.GetCodeButton}`}
                    onClick={resendEmail}
                  >
                    Получить код
                  </button>
                </div>

                <p
                  className={styles.PopupContent_Buttons__DontShow}
                  onClick={() => setStep(1)}
                >
                  Назад
                </p>
              </div>
            </>
          }

          {
            step == 3 &&
            <>
              <div className={styles.PopupContent_ConfirmCode}>

                {errors && <p className={styles.Error}>{errors}</p>}

                <p className={styles.PopupContent_ConfirmCode__Info}>
                  Введите код из письма, которое придет на <br /><b>{newEmail}</b>
                </p>

                <input
                  id="code"
                  name="code"
                  type="text"
                  placeholder="Код из письма"
                  className={errors && styles.RedBorder}
                  value={confirmCode}
                  onChange={(e) => setConfirmCode(e.target.value)}
                />
              </div>

              <div className={styles.PopupContent_ConfirmCodeButtons}>
                <p
                  onClick={requestCodeResend}
                >
                  {
                    count > 0
                      ? `Выслать код повторно через ${count} сек`
                      : "Выслать код повторно"
                  }
                </p>

                <button
                  className={styles.ConfirmCodeButton}
                  onClick={handleConfirmCodeEmail}
                >
                  Подтвердить
                </button>
              </div>
            </>
          }

          {
            step === 4 &&
            <img
              className={styles.SuccesIcon}
              src="/static/images/confirmedPane.svg"
              alt=""
            />
          }
        </div>

      </div>
    </div>
  );
}

export default inject(
  "authStore",
)(observer(TriggerPopup));